const base = process.env.PUBLIC_URL || ``;
export const resources = [
    `${base}/images/AksinyaCabinet.jpg`,
    `${base}/images/AksinyaCabinet2.jpg`,
    `${base}/images/AksinyaEnter.jpg`,
    `${base}/images/AksinyaEnter2.jpg`,
    `${base}/images/AlexCabinet.jpg`,
    `${base}/images/AlexCabinet2.jpg`,
    `${base}/images/AlexEnter.jpg`,
    `${base}/images/AlexEnter2.jpg`,
    `${base}/images/AlexeyCabinet.jpg`,
    `${base}/images/AlexeyEnter.jpg`,
    `${base}/images/analiz_aksinya_1_1_table.jpg`,
    `${base}/images/analiz_aksinya_2_1_table.jpg`,
    `${base}/images/analiz_aksinya_2_2_table.jpg`,
    `${base}/images/analiz_aksinya_2_3_table.jpg`,
    `${base}/images/analiz_aksinya_2_4_table.jpg`,
    `${base}/images/analiz_aksinya_3_1_table.jpg`,
    `${base}/images/analiz_aksinya_3_2_table.jpg`,
    `${base}/images/analiz_aksinya_3_3_table.jpg`,
    `${base}/images/analiz_aksinya_3_4_table.jpg`,
    `${base}/images/analiz_alex_enter_1_table.jpg`,
    `${base}/images/analiz_alex_enter_2_table.jpg`,
    `${base}/images/analiz_alex_enter_3_table.jpg`,
    `${base}/images/analiz_alex_enter_4_table.jpg`,
    `${base}/images/analiz_alex_enter_5_table.jpg`,
    `${base}/images/analiz_alex_visit2_1_table.jpg`,
    `${base}/images/analiz_alex_visit2_2_table.jpg`,
    `${base}/images/analiz_alex_visit2_3_table.jpg`,
    `${base}/images/analiz_alex_visit2_4_table.jpg`,
    `${base}/images/analiz_alex_visit2_5_table.jpg`,
    `${base}/images/analiz_alexey_1_1_table.jpg`,
    `${base}/images/analiz_alexey_1_2_table.jpg`,
    `${base}/images/analiz_alexey_2_1_table.jpg`,
    `${base}/images/analiz_alexey_2_2_table.jpg`,
    `${base}/images/analiz_alexey_2_3_table.jpg`,
    `${base}/images/analiz_alexey_2_4_table.jpg`,
    `${base}/images/analiz_alexey_2_5_table.jpg`,
    `${base}/images/analiz_ivan_e1_1_table.jpg`,
    `${base}/images/analiz_ivan_e1_2_table.jpg`,
    `${base}/images/analiz_ivan_e1_3_table.jpg`,
    `${base}/images/analiz_ivan_e1_4_table.jpg`,
    `${base}/images/analiz_ivan_e1_5_table.jpg`,
    `${base}/images/analiz_ivan_enter_1_table.jpg`,
    `${base}/images/analiz_ivan_enter_2_table.jpg`,
    `${base}/images/analiz_ivan_enter_3_table.jpg`,
    `${base}/images/analiz_ivan_enter_4_table.jpg`,
    `${base}/images/analiz_ivan_enter_5_table.jpg`,
    `${base}/images/analiz_ivan_ep2_1_table.jpg`,
    `${base}/images/analiz_ivan_ep2_2_table.jpg`,
    `${base}/images/analiz_ivan_ep2_3_table.jpg`,
    `${base}/images/analiz_ivan_ep2_4_table.jpg`,
    `${base}/images/analiz_ivan_ep2_5_table.jpg`,
    `${base}/images/analiz_ivan_ep3_1_table.jpg`,
    `${base}/images/analiz_ivan_ep3_2_table.jpg`,
    `${base}/images/analiz_ivan_ep3_3_table.jpg`,
    `${base}/images/analiz_ivan_ep3_4_table.jpg`,
    `${base}/images/analiz_ivan_ep3_5_table.jpg`,
    `${base}/images/analiz_ivan_final_1_table.jpg`,
    `${base}/images/analiz_ivan_final_2_table.jpg`,
    `${base}/images/analiz_ivan_final_3_table.jpg`,
    `${base}/images/analiz_ivan_final_4_table.jpg`,
    `${base}/images/analiz_ivan_final_5_table.jpg`,
    `${base}/images/analiz_ivan_i1_1_table.jpg`,
    `${base}/images/analiz_ivan_i1_2_table.jpg`,
    `${base}/images/analiz_ivan_i1_3_table.jpg`,
    `${base}/images/analiz_ivan_i1_4_table.jpg`,
    `${base}/images/analiz_ivan_i1_5_table.jpg`,
    `${base}/images/analiz_ivan_r2_1_table.jpg`,
    `${base}/images/analiz_ivan_r2_2_table.jpg`,
    `${base}/images/analiz_ivan_r2_3_table.jpg`,
    `${base}/images/analiz_ivan_r2_4_table.jpg`,
    `${base}/images/analiz_ivan_r2_5_table.jpg`,
    `${base}/images/analiz_julia_1_1_table.jpg`,
    `${base}/images/analiz_julia_1_2_table.jpg`,
    `${base}/images/analiz_julia_2_1_table.jpg`,
    `${base}/images/analiz_julia_2_2_table.jpg`,
    `${base}/images/analiz_julia_2_3_table.jpg`,
    `${base}/images/analiz_julia_2_4_table.jpg`,
    `${base}/images/analiz_sergey_e1_1_table.jpg`,
    `${base}/images/analiz_sergey_e1_2_table.jpg`,
    `${base}/images/analiz_sergey_e1_3_table.jpg`,
    `${base}/images/analiz_sergey_e1_4_table.jpg`,
    `${base}/images/analiz_sergey_e1_5_table.jpg`,
    `${base}/images/analiz_sergey_e2_1_table.jpg`,
    `${base}/images/analiz_sergey_e2_2_table.jpg`,
    `${base}/images/analiz_sergey_e2_3_table.jpg`,
    `${base}/images/analiz_sergey_e2_4_table.jpg`,
    `${base}/images/analiz_sergey_e2_5_table.jpg`,
    `${base}/images/analiz_sergey_e3_1_table.jpg`,
    `${base}/images/analiz_sergey_e3_2_table.jpg`,
    `${base}/images/analiz_sergey_e3_3_table.jpg`,
    `${base}/images/analiz_sergey_e3_4_table.jpg`,
    `${base}/images/analiz_sergey_e3_5_table.jpg`,
    `${base}/images/analiz_sergey_enter_1_table.jpg`,
    `${base}/images/analiz_sergey_enter_2_table.jpg`,
    `${base}/images/analiz_sergey_enter_3_table.jpg`,
    `${base}/images/analiz_sergey_enter_4_table.jpg`,
    `${base}/images/analiz_sergey_enter_5_table.jpg`,
    `${base}/images/analiz_sergey_ep1_1_table.jpg`,
    `${base}/images/analiz_sergey_ep1_2_table.jpg`,
    `${base}/images/analiz_sergey_ep1_3_table.jpg`,
    `${base}/images/analiz_sergey_ep1_4_table.jpg`,
    `${base}/images/analiz_sergey_ep1_5_table.jpg`,
    `${base}/images/analiz_sergey_ep2_1_table.jpg`,
    `${base}/images/analiz_sergey_ep2_2_table.jpg`,
    `${base}/images/analiz_sergey_ep2_3_table.jpg`,
    `${base}/images/analiz_sergey_ep2_4_table.jpg`,
    `${base}/images/analiz_sergey_ep2_5_table.jpg`,
    `${base}/images/analiz_sergey_ipta2_1_table.jpg`,
    `${base}/images/analiz_sergey_ipta2_2_table.jpg`,
    `${base}/images/analiz_sergey_ipta2_3_table.jpg`,
    `${base}/images/analiz_sergey_ipta2_4_table.jpg`,
    `${base}/images/analiz_sergey_ipta2_5_table.jpg`,
    `${base}/images/analiz_sergey_ipta3_1_table.jpg`,
    `${base}/images/analiz_sergey_ipta3_2_table.jpg`,
    `${base}/images/analiz_sergey_ipta3_3_table.jpg`,
    `${base}/images/analiz_sergey_ipta3_4_table.jpg`,
    `${base}/images/analiz_sergey_ipta3_5_table.jpg`,
    `${base}/images/analiz_sergey_r1_1_table.jpg`,
    `${base}/images/analiz_sergey_r1_2_table.jpg`,
    `${base}/images/analiz_sergey_r1_3_table.jpg`,
    `${base}/images/analiz_sergey_r1_4_table.jpg`,
    `${base}/images/analiz_sergey_r1_5_table.jpg`,
    `${base}/images/analiz_sergey_r2_1_table.jpg`,
    `${base}/images/analiz_sergey_r2_2_table.jpg`,
    `${base}/images/analiz_sergey_r2_3_table.jpg`,
    `${base}/images/analiz_sergey_r2_4_table.jpg`,
    `${base}/images/analiz_sergey_r2_5_table.jpg`,
    `${base}/images/analiz_sergey_r3_1_table.jpg`,
    `${base}/images/analiz_sergey_r3_2_table.jpg`,
    `${base}/images/analiz_sergey_r3_3_table.jpg`,
    `${base}/images/analiz_sergey_r3_4_table.jpg`,
    `${base}/images/analiz_sergey_r3_5_table.jpg`,
    `${base}/images/analiz_vera_1_1_table.jpg`,
    `${base}/images/analiz_vera_1_2_table.jpg`,
    `${base}/images/analiz_vera_1_3_table.jpg`,
    `${base}/images/analiz_vera_2_2_table.jpg`,
    `${base}/images/analiz_vera_2_3_table.jpg`,
    `${base}/images/analiz_vera_3_3_table.jpg`,
    `${base}/images/analiz_vera_4_3_table.jpg`,
    `${base}/images/analiz_vera_5_3_table.jpg`,
    `${base}/images/blur.jpg`,
    `${base}/images/cabinet_card.jpg`,
    `${base}/images/cabinet.jpg`,
    `${base}/images/cabinetLook.jpg`,
    `${base}/images/car.jpg`,
    `${base}/images/city.jpg`,
    `${base}/images/doctorCenter.jpg`,
    `${base}/images/enter_door.jpg`,
    `${base}/images/enter.jpg`,
    `${base}/images/hospital.jpg`,
    `${base}/images/IvanCabinet.jpg`,
    `${base}/images/IvanCabinet2.jpg`,
    `${base}/images/IvanEnter.jpg`,
    `${base}/images/JuliaCabinet.jpg`,
    `${base}/images/JuliaEnter.jpg`,
    `${base}/images/learn_bg.jpg`,
    `${base}/images/learn2_bg.jpg`,
    `${base}/images/learn3_bg.jpg`,
    `${base}/images/mech1_1.jpg`,
    `${base}/images/mech1_2.jpg`,
    `${base}/images/mech1_3.jpg`,
    `${base}/images/mech2_1.jpg`,
    `${base}/images/mech2_2.jpg`,
    `${base}/images/mech2_3.jpg`,
    `${base}/images/openImage.jpg`,
    `${base}/images/patirnt1_analiz1_header.jpg`,
    `${base}/images/patirnt1_analiz1_table_res.jpg`,
    `${base}/images/patirnt1_analiz1_table.jpg`,
    `${base}/images/patirnt1_analiz1_table0.jpg`,
    `${base}/images/patirnt1_analiz2_header.jpg`,
    `${base}/images/patirnt1_analiz2_table_res.jpg`,
    `${base}/images/patirnt1_analiz2_table.jpg`,
    `${base}/images/patirnt1_analiz2_table0.jpg`,
    `${base}/images/patirnt1_analiz3_header.jpg`,
    `${base}/images/patirnt1_analiz3_table_res.jpg`,
    `${base}/images/patirnt1_analiz3_table.jpg`,
    `${base}/images/patirnt1_analiz3_table0.jpg`,
    `${base}/images/patirnt1_analiz4_header.jpg`,
    `${base}/images/patirnt1_analiz4_table_res.jpg`,
    `${base}/images/patirnt1_analiz4_table.jpg`,
    `${base}/images/patirnt1_analiz5_1_table_res_.jpg`,
    `${base}/images/patirnt1_analiz5_1_table_res.jpg`,
    `${base}/images/patirnt1_analiz5_1_table.jpg`,
    `${base}/images/patirnt1_analiz5_1_table0.jpg`,
    `${base}/images/patirnt1_analiz5_header__.jpg`,
    `${base}/images/patirnt1_analiz5_header.jpg`,
    `${base}/images/patirnt1_analiz5_table.jpg`,
    `${base}/images/patirnt1_analiz5_table0.jpg`,
    `${base}/images/prize0.jpg`,
    `${base}/images/prize1.jpg`,
    `${base}/images/prize2.jpg`,
    `${base}/images/prize3.jpg`,
    `${base}/images/SergeyCabinet.jpg`,
    `${base}/images/SergeyCabinet2.jpg`,
    `${base}/images/SergeyEnter.jpg`,
    `${base}/images/SergeyEnter2.jpg`,
    `${base}/images/station.jpg`,
    `${base}/images/teach_day1_0_1.jpg`,
    `${base}/images/teach_day1_0_2.jpg`,
    `${base}/images/teach_day1_0_3.jpg`,
    `${base}/images/teach_day1_0_4.jpg`,
    `${base}/images/teach_day1_0_5.jpg`,
    `${base}/images/teach_day1_0_6.jpg`,
    `${base}/images/teach1_1.jpg`,
    `${base}/images/teach1_2.jpg`,
    `${base}/images/teach1_3.jpg`,
    `${base}/images/teach1_4.jpg`,
    `${base}/images/teach1_5.jpg`,
    `${base}/images/teach1_6.jpg`,
    `${base}/images/tuktuk.jpg`,
    `${base}/images/VeraCabinet.jpg`,
    `${base}/images/VeraEnter.jpg`,
    `${base}/images/aksinya_teach1_1.png`,
    `${base}/images/aksinya_teach1_2.png`,
    `${base}/images/aksinya_teach1_3.png`,
    `${base}/images/aksinya_teach2_1.png`,
    `${base}/images/aksinya_teach2_2.png`,
    `${base}/images/alex_teach_enter_1.png`,
    `${base}/images/alex_teach_enter_2.png`,
    `${base}/images/alex_teach_enter_3.png`,
    `${base}/images/alex_teach_enter_11.png`,
    `${base}/images/alex_teach_enter_12.png`,
    `${base}/images/alexey_teach1_1.png`,
    `${base}/images/alexey_teach2_1_old.png`,
    `${base}/images/alexey_teach2_1.png`,
    `${base}/images/alexey_teach2_2.png`,
    `${base}/images/alexey_teach2_3.png`,
    `${base}/images/alexey_teach3_1.png`,
    `${base}/images/alexey_teach3_2.png`,
    `${base}/images/alexey_teach3_3.png`,
    `${base}/images/alexey_teach3_4.png`,
    `${base}/images/cabinet.png`,
    `${base}/images/enter_patient.png`,
    `${base}/images/gematogen_close.png`,
    `${base}/images/gematogen.png`,
    `${base}/images/gematogenOpen.png`,
    `${base}/images/gemo.png`,
    `${base}/images/ivan_teach_e1_1.png`,
    `${base}/images/ivan_teach_e1_2.png`,
    `${base}/images/ivan_teach_e1_3.png`,
    `${base}/images/ivan_teach_e1_4.png`,
    `${base}/images/ivan_teach_e1_5.png`,
    `${base}/images/ivan_teach_e1_11.png`,
    `${base}/images/ivan_teach_e1_12.png`,
    `${base}/images/ivan_teach_e1_13.png`,
    `${base}/images/ivan_teach_e1_14.png`,
    `${base}/images/ivan_teach_enter_1.png`,
    `${base}/images/ivan_teach_enter_2.png`,
    `${base}/images/ivan_teach_enter_3.png`,
    `${base}/images/ivan_teach_ep2_1.png`,
    `${base}/images/ivan_teach_ep2_2.png`,
    `${base}/images/ivan_teach_ep2_3.png`,
    `${base}/images/ivan_teach_ep2_4.png`,
    `${base}/images/ivan_teach_ep2_5.png`,
    `${base}/images/nadya_speak.png`,
    `${base}/images/nadya.png`,
    `${base}/images/patient_aksinya_card1.png`,
    `${base}/images/patient_aksinya_card2.png`,
    `${base}/images/patient_alex_card1_2.png`,
    `${base}/images/patient_alex_card1.png`,
    `${base}/images/patient_alex_card2_2.png`,
    `${base}/images/patient_alex_card2.png`,
    `${base}/images/patient_alexey_card1.png`,
    `${base}/images/patient_alexey_card2.png`,
    `${base}/images/patient_ivan_e1_card1.png`,
    `${base}/images/patient_ivan_e1_card2.png`,
    `${base}/images/patient_ivan_enter_card1.png`,
    `${base}/images/patient_ivan_enter_card2.png`,
    `${base}/images/patient_ivan_ep2_ep3_card1.png`,
    `${base}/images/patient_ivan_ep2_ep3_card2.png`,
    `${base}/images/patient_ivan_i1_final_card1.png`,
    `${base}/images/patient_ivan_i1_final_card2.png`,
    `${base}/images/patient_ivan_r2_card1.png`,
    `${base}/images/patient_ivan_r2_card2.png`,
    `${base}/images/patient_julia_card1.png`,
    `${base}/images/patient_julia_card2.png`,
    `${base}/images/patient_sergey_card2.png`,
    `${base}/images/patient_sergey_e1_card1.png`,
    `${base}/images/patient_sergey_e2_e3_card1.png`,
    `${base}/images/patient_sergey_enter_card1.png`,
    `${base}/images/patient_sergey_ep1_ep2_card1.png`,
    `${base}/images/patient_sergey_ipta2_ipta3_card1.png`,
    `${base}/images/patient_sergey_r1_r2_r3_card1.png`,
    `${base}/images/patient_vera_card1.png`,
    `${base}/images/patient_vera_card2_2.png`,
    `${base}/images/patient_vera_card2.png`,
    `${base}/images/patient1_card_2.png`,
    `${base}/images/patient1_card.png`,
    `${base}/images/patient1_card2.png`,
    `${base}/images/patient1.png`,
    `${base}/images/patirnt1_analiz2_header.png`,
    `${base}/images/prize_border1.png`,
    `${base}/images/prize_border2.png`,
    `${base}/images/prize_border3.png`,
    `${base}/images/prize_close.png`,
    `${base}/images/prize1_card.png`,
    `${base}/images/prize1.png`,
    `${base}/images/prize2_card.png`,
    `${base}/images/prize2.png`,
    `${base}/images/prize3_card.png`,
    `${base}/images/prize3.png`,
    `${base}/images/prize4.png`,
    `${base}/images/prize5.png`,
    `${base}/images/sergey_teach_e1_1.png`,
    `${base}/images/sergey_teach_e2_1.png`,
    `${base}/images/sergey_teach_e2_2.png`,
    `${base}/images/sergey_teach_e2_3.png`,
    `${base}/images/sergey_teach_e2_11.png`,
    `${base}/images/sergey_teach_e2_12.png`,
    `${base}/images/sergey_teach_enter_1.png`,
    `${base}/images/sergey_teach_enter_2.png`,
    `${base}/images/sergey_teach_enter_3.png`,
    `${base}/images/sergey_teach_enter_4.png`,
    `${base}/images/sergey_teach_enter_5.png`,
    `${base}/images/sergey_teach_enter_6.png`,
    `${base}/images/sergey_teach_enter_7.png`,
    `${base}/images/sergey_teach_enter_8.png`,
    `${base}/images/sergey_teach_enter_11.png`,
    `${base}/images/sergey_teach_enter_12.png`,
    `${base}/images/sergey_teach_ep1_1.png`,
    `${base}/images/sergey_teach_ep1_2.png`,
    `${base}/images/sergey_teach_ep1_3.png`,
    `${base}/images/sergey_teach_ep1_11.png`,
    `${base}/images/sergey_teach_ep1_12.png`,
    `${base}/images/sergey_teach_ep1_13.png`,
    `${base}/images/sergey_teach_r1_1.png`,
    `${base}/images/sergey_teach_r2_1.png`,
    `${base}/images/sergey_teach_r2_2.png`,
    `${base}/images/sergey_teach_r2_3.png`,
    `${base}/images/sergey_teach_r2_11.png`,
    `${base}/images/sergey_teach_r2_12.png`,
    `${base}/images/sergey_teach_r2_13.png`,
    `${base}/images/sergey_teach_r3_1.png`,
    `${base}/images/sergey_teach_r3_2.png`,
    `${base}/images/table_disable.png`,
    `${base}/images/table.png`,
    `${base}/images/tuk1.png`,
    `${base}/images/tuk2.png`,
    `${base}/images/vera_questions1.png`,
    `${base}/images/vera_questions2.png`,
    `${base}/images/vera_teach1_1.png`,
    `${base}/images/vera_teach1_2.png`,
    `${base}/images/vera_teach1_3.png`,
    `${base}/images/view_card_btn.png`,
    `${base}/images/view_info_btn.png`,
    `/analiz_aksinya_1_1_table.png`,
    `${base}/images/analiz_left/analiz_aksinya_2_1_table.png`,
    `${base}/images/analiz_left/analiz_aksinya_2_2_table.png`,
    `${base}/images/analiz_left/analiz_aksinya_2_3_table.png`,
    `${base}/images/analiz_left/analiz_aksinya_2_4_table.png`,
    `${base}/images/analiz_left/analiz_aksinya_3_1_table.png`,
    `${base}/images/analiz_left/analiz_aksinya_3_2_table.png`,
    `${base}/images/analiz_left/analiz_aksinya_3_3_table.png`,
    `${base}/images/analiz_left/analiz_aksinya_3_4_table.png`,
    `${base}/images/analiz_left/analiz_alex_enter_1_table.png`,
    `${base}/images/analiz_left/analiz_alex_enter_2_table.png`,
    `${base}/images/analiz_left/analiz_alex_enter_3_table.png`,
    `${base}/images/analiz_left/analiz_alex_enter_4_table.png`,
    `${base}/images/analiz_left/analiz_alex_enter_5_table.png`,
    `${base}/images/analiz_left/analiz_alex_visit2_1_table.png`,
    `${base}/images/analiz_left/analiz_alex_visit2_2_table.png`,
    `${base}/images/analiz_left/analiz_alex_visit2_3_table.png`,
    `${base}/images/analiz_left/analiz_alex_visit2_4_table.png`,
    `${base}/images/analiz_left/analiz_alex_visit2_5_table.png`,
    `${base}/images/analiz_left/analiz_alexey_1_1_table.png`,
    `${base}/images/analiz_left/analiz_alexey_1_2_table.png`,
    `${base}/images/analiz_left/analiz_alexey_2_1_table.png`,
    `${base}/images/analiz_left/analiz_alexey_2_2_table.png`,
    `${base}/images/analiz_left/analiz_alexey_2_3_table.png`,
    `${base}/images/analiz_left/analiz_alexey_2_4_table.png`,
    `${base}/images/analiz_left/analiz_alexey_2_5_table.png`,
    `${base}/images/analiz_left/analiz_ivan_e1_1_table.png`,
    `${base}/images/analiz_left/analiz_ivan_e1_2_table.png`,
    `${base}/images/analiz_left/analiz_ivan_e1_3_table.png`,
    `${base}/images/analiz_left/analiz_ivan_e1_4_table.png`,
    `${base}/images/analiz_left/analiz_ivan_e1_5_table.png`,
    `${base}/images/analiz_left/analiz_ivan_enter_1_table.png`,
    `${base}/images/analiz_left/analiz_ivan_enter_2_table.png`,
    `${base}/images/analiz_left/analiz_ivan_enter_3_table.png`,
    `${base}/images/analiz_left/analiz_ivan_enter_4_table.png`,
    `${base}/images/analiz_left/analiz_ivan_enter_5_table.png`,
    `${base}/images/analiz_left/analiz_ivan_ep2_1_table.png`,
    `${base}/images/analiz_left/analiz_ivan_ep2_2_table.png`,
    `${base}/images/analiz_left/analiz_ivan_ep2_3_table.png`,
    `${base}/images/analiz_left/analiz_ivan_ep2_4_table.png`,
    `${base}/images/analiz_left/analiz_ivan_ep2_5_table.png`,
    `${base}/images/analiz_left/analiz_ivan_ep3_1_table.png`,
    `${base}/images/analiz_left/analiz_ivan_ep3_2_table.png`,
    `${base}/images/analiz_left/analiz_ivan_ep3_3_table.png`,
    `${base}/images/analiz_left/analiz_ivan_ep3_4_table.png`,
    `${base}/images/analiz_left/analiz_ivan_ep3_5_table.png`,
    `${base}/images/analiz_left/analiz_ivan_final_1_table.png`,
    `${base}/images/analiz_left/analiz_ivan_final_2_table.png`,
    `${base}/images/analiz_left/analiz_ivan_final_3_table.png`,
    `${base}/images/analiz_left/analiz_ivan_final_4_table.png`,
    `${base}/images/analiz_left/analiz_ivan_final_5_table.png`,
    `${base}/images/analiz_left/analiz_ivan_i1_1_table.png`,
    `${base}/images/analiz_left/analiz_ivan_i1_2_table.png`,
    `${base}/images/analiz_left/analiz_ivan_i1_3_table.png`,
    `${base}/images/analiz_left/analiz_ivan_i1_4_table.png`,
    `${base}/images/analiz_left/analiz_ivan_i1_5_table.png`,
    `${base}/images/analiz_left/analiz_ivan_r2_1_table.png`,
    `${base}/images/analiz_left/analiz_ivan_r2_2_table.png`,
    `${base}/images/analiz_left/analiz_ivan_r2_3_table.png`,
    `${base}/images/analiz_left/analiz_ivan_r2_4_table.png`,
    `${base}/images/analiz_left/analiz_ivan_r2_5_table.png`,
    `${base}/images/analiz_left/analiz_julia_1_1_table.png`,
    `${base}/images/analiz_left/analiz_julia_1_2_table.png`,
    `${base}/images/analiz_left/analiz_julia_2_1_table.png`,
    `${base}/images/analiz_left/analiz_julia_2_2_table.png`,
    `${base}/images/analiz_left/analiz_julia_2_3_table.png`,
    `${base}/images/analiz_left/analiz_julia_2_4_table.png`,
    `${base}/images/analiz_left/analiz_sergey_e1_1_table.png`,
    `${base}/images/analiz_left/analiz_sergey_e1_2_table.png`,
    `${base}/images/analiz_left/analiz_sergey_e1_3_table.png`,
    `${base}/images/analiz_left/analiz_sergey_e1_4_table.png`,
    `${base}/images/analiz_left/analiz_sergey_e1_5_table.png`,
    `${base}/images/analiz_left/analiz_sergey_e2_1_table.png`,
    `${base}/images/analiz_left/analiz_sergey_e2_2_table.png`,
    `${base}/images/analiz_left/analiz_sergey_e2_3_table.png`,
    `${base}/images/analiz_left/analiz_sergey_e2_4_table.png`,
    `${base}/images/analiz_left/analiz_sergey_e2_5_table.png`,
    `${base}/images/analiz_left/analiz_sergey_e3_1_table.png`,
    `${base}/images/analiz_left/analiz_sergey_e3_2_table.png`,
    `${base}/images/analiz_left/analiz_sergey_e3_3_table.png`,
    `${base}/images/analiz_left/analiz_sergey_e3_4_table.png`,
    `${base}/images/analiz_left/analiz_sergey_e3_5_table.png`,
    `${base}/images/analiz_left/analiz_sergey_enter_1_table.png`,
    `${base}/images/analiz_left/analiz_sergey_enter_2_table.png`,
    `${base}/images/analiz_left/analiz_sergey_enter_3_table.png`,
    `${base}/images/analiz_left/analiz_sergey_enter_4_table.png`,
    `${base}/images/analiz_left/analiz_sergey_enter_5_table.png`,
    `${base}/images/analiz_left/analiz_sergey_ep1_1_table.png`,
    `${base}/images/analiz_left/analiz_sergey_ep1_2_table.png`,
    `${base}/images/analiz_left/analiz_sergey_ep1_3_table.png`,
    `${base}/images/analiz_left/analiz_sergey_ep1_4_table.png`,
    `${base}/images/analiz_left/analiz_sergey_ep1_5_table.png`,
    `${base}/images/analiz_left/analiz_sergey_ep2_1_table.png`,
    `${base}/images/analiz_left/analiz_sergey_ep2_2_table.png`,
    `${base}/images/analiz_left/analiz_sergey_ep2_3_table.png`,
    `${base}/images/analiz_left/analiz_sergey_ep2_4_table.png`,
    `${base}/images/analiz_left/analiz_sergey_ep2_5_table.png`,
    `${base}/images/analiz_left/analiz_sergey_ipta2_1_table.png`,
    `${base}/images/analiz_left/analiz_sergey_ipta2_2_table.png`,
    `${base}/images/analiz_left/analiz_sergey_ipta2_3_table.png`,
    `${base}/images/analiz_left/analiz_sergey_ipta2_4_table.png`,
    `${base}/images/analiz_left/analiz_sergey_ipta2_5_table.png`,
    `${base}/images/analiz_left/analiz_sergey_ipta3_1_table.png`,
    `${base}/images/analiz_left/analiz_sergey_ipta3_2_table.png`,
    `${base}/images/analiz_left/analiz_sergey_ipta3_3_table.png`,
    `${base}/images/analiz_left/analiz_sergey_ipta3_4_table.png`,
    `${base}/images/analiz_left/analiz_sergey_ipta3_5_table.png`,
    `${base}/images/analiz_left/analiz_sergey_r1_1_table.png`,
    `${base}/images/analiz_left/analiz_sergey_r1_2_table.png`,
    `${base}/images/analiz_left/analiz_sergey_r1_3_table.png`,
    `${base}/images/analiz_left/analiz_sergey_r1_4_table.png`,
    `${base}/images/analiz_left/analiz_sergey_r1_5_table.png`,
    `${base}/images/analiz_left/analiz_sergey_r2_1_table.png`,
    `${base}/images/analiz_left/analiz_sergey_r2_2_table.png`,
    `${base}/images/analiz_left/analiz_sergey_r2_3_table.png`,
    `${base}/images/analiz_left/analiz_sergey_r2_4_table.png`,
    `${base}/images/analiz_left/analiz_sergey_r2_5_table.png`,
    `${base}/images/analiz_left/analiz_sergey_r3_1_table.png`,
    `${base}/images/analiz_left/analiz_sergey_r3_2_table.png`,
    `${base}/images/analiz_left/analiz_sergey_r3_3_table.png`,
    `${base}/images/analiz_left/analiz_sergey_r3_4_table.png`,
    `${base}/images/analiz_left/analiz_sergey_r3_5_table.png`,
    `${base}/images/analiz_left/analiz_vera_1_1_table.png`,
    `${base}/images/analiz_left/analiz_vera_1_2_table.png`,
    `${base}/images/analiz_left/analiz_vera_1_3_table.png`,
    `${base}/images/analiz_left/analiz_vera_2_2_table.png`,
    `${base}/images/analiz_left/analiz_vera_2_3_table.png`,
    `${base}/images/analiz_left/analiz_vera_3_3_table.png`,
    `${base}/images/analiz_left/analiz_vera_4_3_table.png`,
    `${base}/images/analiz_left/analiz_vera_5_3_table.png`,
    `${base}/images/analyze_arrow.svg`,
    `${base}/images/burger.svg`,
    `${base}/images/button_next.svg`,
    `${base}/images/button_prev.svg`,
    `${base}/images/close_teach.svg`,
    `${base}/images/close.svg`,
    `${base}/images/info.svg`,
    `${base}/images/instruction.svg`,
    `${base}/images/next_btn.svg`,
    `${base}/images/pcbg.svg`,
    `${base}/images/prev_btn.svg`,
    `${base}/images/rating.svg`,
    `${base}/images/sound_off.svg`,
    `${base}/images/sound.svg`,
    `${base}/images/window.svg`
];
